import { PillUnit } from '@mark43/cad-api';
import type { UnitStatusColors } from '../../configurable-colors-sounds/unit-status-colors';
import { getColorForHeldUnit } from '../helpers/styles';

export type UnitPillColors = { fill: string; outline?: string; text: string };

const SELECTED_COLORS = {
    fill: 'var(--arc-colors-selected-default)',
    outline: 'var(--arc-colors-selected-default)',
    text: 'var(--arc-colors-selected-content)',
};

const GHOST_COLORS = {
    fill: '',
    outline: 'var(--arc-colors-text-tertiary)',
    text: 'var(--arc-colors-text-tertiary)',
};

/**
 * The colors of a unit pill. A ghost pill wins over a held unit, and a held unit over its status
 * colors. While the pill's context menu is open it shows the selected colors instead.
 */
export function getUnitPillColors({
    unit,
    variant,
    statusColors,
    isContextMenuOpen,
}: {
    unit: PillUnit;
    variant: 'default' | 'ghost';
    statusColors: UnitStatusColors;
    isContextMenuOpen: boolean;
}): UnitPillColors {
    let baseColors: UnitPillColors;
    if (variant === 'ghost') {
        baseColors = { ...GHOST_COLORS };
    } else if (unit.isHeld) {
        baseColors = { fill: '', ...getColorForHeldUnit(unit) };
    } else {
        baseColors = statusColors;
    }

    if (!isContextMenuOpen) {
        return baseColors;
    }
    // Keep the border only if the pill already has one, so selecting it doesn't change its size.
    // The selected fill and outline are the same color, so the border adds nothing visually.
    return {
        ...SELECTED_COLORS,
        outline: baseColors.outline ? SELECTED_COLORS.outline : undefined,
    };
}
